import { ChatMessage } from './chat-message';

export class Chat {
  defaultList: ChatMessage[] = [
    new ChatMessage(
      'default$1',
      'Vous pouvez redémarrer le chatbot à tout moment. Écrivez juste "start". ',
      'bot',
    ),
    new ChatMessage(
      'default$2',
      "Je suis en train d'élargir mes connaissances. Bientôt, vous pourrez me poser des questions sur tout ce qui concerne Infodata.",
      'bot',
    ),
    new ChatMessage(
      'default$3',
      "À l'heure actuelle, vous pouvez me poser des questions générales sur les sujets suivants.",
      'bot',
    ),
    new ChatMessage('default$4', 'Choisissez un sujet', 'bot'),
    // new ChatMessage(
    //   'preselection',
    //   'Comment créer une pré-sélection ?',
    //   'action'
    // ),
    // new ChatMessage('bandeau', 'Utiliser le bandeau', 'action'),
    // new ChatMessage('utilisateurs', 'Voir plusieurs utilisateurs', 'action'),
    // new ChatMessage(
    //   'teletravail',
    //   'Voir le nombre de jours de télétravail',
    //   'action'
    // ),
    // new ChatMessage(
    //   'confidentialite',
    //   'Politique de confidentialité',
    //   'action'
    // ),
  ];
}
